import HubEpworthQuizResultsPage from './HubEpworthQuizResultsPage'

export default HubEpworthQuizResultsPage
